import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";

export const Route = createFileRoute("/")({
  component: IndexPage,
});

/**
 * Landing page. Auto-redirects authenticated users to /dashboard, and
 * unauthenticated users into the OpenAuth PKCE flow. Renders a centered
 * spinner during the brief moment before either redirect fires.
 */
function IndexPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (auth.status === "authenticated") {
      void navigate({ to: "/dashboard", replace: true });
    } else if (auth.status === "unauthenticated") {
      void auth.signIn("/dashboard");
    }
  }, [auth, auth.status, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <span className="text-sm">{t("auth.redirecting")}</span>
      </div>
    </div>
  );
}
